import { scan } from "react-scan";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { Auth0Provider, useAuth0 } from "@auth0/auth0-react";
import { RouterProvider } from "@tanstack/react-router";

import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";

import router from "router";

import QueryProvider from "@subly/s1/ui/composed/QueryProvider";

import { useStart } from "features/start/fabric";


scan({ enabled: true });

const App = ({ children }: { children: React.ReactNode }) => {
	const start = useStart();

	return (
		<Auth0Provider
			domain={start.settings.auth0.domain}
			clientId={start.settings.auth0.clientId}
			useRefreshTokens
			useRefreshTokensFallback
			cacheLocation="localstorage"
			authorizationParams={{
				redirect_uri: window.location.origin,
				response_type: "code",
				audience: start.settings.auth0.audience,
				scope: start.settings.auth0.scope,
				screen_hint: "login"
			}}
		>
			{children}
		</Auth0Provider>
	);
};

const Router = () => {
	const auth0 = useAuth0();

	if (auth0.isLoading) return null;
	return <RouterProvider router={router} context={{ auth0 }} />;
};

const rootElement = document.getElementById("root");
if (rootElement && !rootElement.innerHTML) {
	const root = ReactDOM.createRoot(rootElement);
	root.render(
		<StrictMode>
			<QueryProvider>
				<LocalizationProvider dateAdapter={AdapterDateFns}>
					<App>
						<Router />
					</App>
				</LocalizationProvider>
			</QueryProvider>
		</StrictMode>
	);
}